export const DealTokenRefConstants = {
    GET_ALL_DEAL_TOKEN_REF_PAGINATE_SUCCESS: 'GET_ALL_DEAL_TOKEN_REF_PAGINATE_SUCCESS',
    GET_ALL_DEAL_TOKEN_REF_PAGINATE_ERROR: 'GET_ALL_DEAL_TOKEN_REF_PAGINATE_ERROR',
    DEAL_TOKEN_REF_LOADING_STATUS: 'DEAL_TOKEN_REF_LOADING_STATUS',

    DEAL_TOKEN_REF_CURRENT_PAGE: 'DEAL_TOKEN_REF_CURRENT_PAGE',
    DEAL_TOKEN_REF_LIMIT_PER_PAGE: 'DEAL_TOKEN_REF_LIMIT_PER_PAGE',
    DEAL_TOKEN_REF_TOTAL_COUNT: 'DEAL_TOKEN_REF_TOTAL_COUNT',
}